



import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState, useRef } from "react";

const imageSet1 = [
    "/images/landing/set1.1.avif",
    "/images/landing/set1.2.avif",
    "/images/landing/set1.3.avif",
];

const imageSet2 = [
    "/images/landing/set2.1.webp",
    "/images/landing/set2.2.avif",
    "/images/landing/set2.3.avif",
];

const imageSet3 = [
    "/images/landing/set3.1.avif",
    "/images/landing/set3.2.avif",
    "/images/landing/set3.3.avif",
];

const imageSet4 = [
    "/images/landing/set4.1.avif",
    "/images/landing/set4.2.webp",
    "/images/landing/set4.3.avif",
];


const imageSets = [imageSet2, imageSet1, imageSet4, imageSet3];

export default function LandingImageCarousel() {
    const totalVisibleBlocks = 40;
    const staggeredSets = Array.from({ length: totalVisibleBlocks }, (_, i) => imageSets[i % imageSets.length]);

    return (
        
        <Box
            sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-30deg) scale(0.8)",
                overflow: "hidden",
                zIndex: 0,
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
           <motion.div
                initial={{ x: '0%' }}
                animate={{ x: ["0%", "-50%"] }}
                transition={{
                    repeat: Infinity,
                    duration: 650,
                    ease: "linear",
                }}
                style={{
                    display: "flex",
                    width: "max-content",
                    gap: '200px',
                    right: 10,
                }}
            >
                {[...staggeredSets, ...staggeredSets].map((set, index) => {
                    const isNarrow = index % 2 !== 0;


                    const width = isNarrow ? 316.92 : 474.41;
                    const height = isNarrow ? 406.2 : 301.7;
                    const verticalOffset = isNarrow ? "-160px" : "160px";

                    return (
                    <Box
                        key={index}
                        sx={{
                            borderRadius: 2,
                            overflow: "hidden",
                            height: "800px",
                            position: "relative",
                            marginTop: verticalOffset,
                            flexShrink: 0,
                            mx: "100px",
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <ImageLoop
                            images={set}
                            delay={(index % imageSets.length) * 500}
                            width={width}
                            height={height}
                        />
                    </Box>
                    );
                })}
            </motion.div>
        </Box>
    );
}
  
function ImageLoop({
        images,
        delay = 0,
        width,
        height,
    }: {
        images: string[];
        delay?: number;
        width: number;
        height: number;
    }) {
    const [index, setIndex] = useState(0);
    const requestRef = useRef<number | undefined>(undefined);
    const startTimeRef = useRef<number | undefined>(undefined);

    const durationPerImage = width < 400 ? 560 : 500;

    useEffect(() => {
        const animate = (timestamp: number) => {
            if (!startTimeRef.current) startTimeRef.current = timestamp;
            const elapsed = timestamp - startTimeRef.current + delay;

            const newIndex = Math.floor(elapsed / durationPerImage) % images.length;
            setIndex(newIndex);

            requestRef.current = requestAnimationFrame(animate);
        };

        requestRef.current = requestAnimationFrame(animate);

        return () => {
            if (requestRef.current) cancelAnimationFrame(requestRef.current);
        };
    }, [images.length, delay]);

    return (
        <Box
            sx={{
                width: `${width}px`,
                height: `${height}px`,
                borderRadius: 2,
                overflow: "hidden",
                position: "relative",
                flexShrink: 0,
                background: "#eee",
            }}
        >
            {images.map((img, i) => (
                <motion.img
                    key={img}
                    src={img}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        opacity: i === index ? 1 : 0,
                        pointerEvents: "none",
                        userSelect: "none",
                    }}
                    alt=""
                    draggable={false}
                />
            ))}
        </Box>
    );
}
